import $ from 'jquery';

export default class Loader {

  constructor($target) {
    this.$target = $target;
    this.dataObjectName = 'loader';

    if (this.$target.data(this.dataObjectName)) {
      return this.$target.data(this.dataObjectName);
    }

    this.visibilityClass = 'hidden';
    this.cntClass = 'overlay';
    this.fadeTimeout = 200;
    this.fadeOpacity = 1;
    this.$el = $('<div class="' + this.cntClass + ' ' + this.visibilityClass + '">' +
      '<div class="sk-fading-circle">' +
      '<div class="sk-circle1 sk-circle"></div>' +
      '<div class="sk-circle2 sk-circle"></div>' +
      '<div class="sk-circle3 sk-circle"></div>' +
      '<div class="sk-circle4 sk-circle"></div>' +
      '<div class="sk-circle5 sk-circle"></div>' +
      '<div class="sk-circle6 sk-circle"></div>' +
      '<div class="sk-circle7 sk-circle"></div>' +
      '<div class="sk-circle8 sk-circle"></div>' +
      '<div class="sk-circle9 sk-circle"></div>' +
      '<div class="sk-circle10 sk-circle"></div>' +
      '<div class="sk-circle11 sk-circle"></div>' +
      '<div class="sk-circle12 sk-circle"></div>' +
      '</div>');

    this.$target.data(this.dataObjectName, this);

    return this;
  }

  show() {
    if (!this.$target.length) {
      return;
    }

    if (this.$target.css('position') === 'static') {
      this.$target.css('position', 'relative');
    }

    // tak na wszelki wypadek
    if (this.$target.find(this.cntClass).length) {
      this.$el = this.$target.find(this.cntClass);
    }

    this.$target.append(this.$el);
    this.$el
      .removeClass(this.visibilityClass)
      .fadeTo(this.fadeTimeout, this.fadeOpacity);
  }

  remove() {
    this.$el.fadeTo(this.fadeTimeout, 0, () => {
      this.$el.remove();
    });
  }

}



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/app/loader.js